let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kMTLc")).then(() => parcelRequire('cu32w'));